<script>
import { defineComponent, onMounted } from 'vue';
import { useModalController, useToastController } from 'bootstrap-vue-next';
import { setBootstrapControllers } from '@/modules/bootstrapCompat';

export default defineComponent({
  name: 'BootstrapControllerBridge',
  setup() {
    const modalController = useModalController();
    const toastController = useToastController();

    onMounted(() => {
      setBootstrapControllers(modalController, toastController);
    });

    return () => null;
  },
});
</script>
